<template>
  <div class="action-timeline" id="action-timeline">
  </div>
</template>

<script>
  // H5 动作编辑器时间轴（替代原 ActionEditorTimeline.swf）
  // 移植自 AS3 TimelineWindow：主时间轴+部件子时间轴，逐帧编辑
  import ActionEditorTimeline from '@/common/scripts/pixi/ActionEditorTimeline.js'

  export default {
    data () {
      return {
        timeline: null
      }
    },
    mounted () {
      let platform = this.$route.query.platform
      let con = document.getElementById('action-timeline')
      this.timeline = new ActionEditorTimeline(con)
      this.timeline.start(platform, ACTIONTIMELINE, ACTIONTIMELINE_NAME)
    },
    activated () {
      // keep-alive 重新激活/进入动作编辑布局时重算尺寸并拉取最新时间轴
      if (this.timeline) {
        this.timeline.resize()
        this.timeline.send(7, 3, null)
      }
    },
    beforeDestroy () {
      if (this.timeline && this.timeline._resizeObserver) {
        this.timeline._resizeObserver.disconnect()
      }
      if (this.timeline && this.timeline._onKeyDown) {
        window.removeEventListener('keydown', this.timeline._onKeyDown)
        this.timeline._onKeyDown = null
      }
    }
  }
</script>

<style lang="stylus">
  .action-timeline
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    background: #f5f5f5
</style>



// WEBPACK FOOTER //
// ActionTimeline.vue?da1faa9e